import { Confirm } from '@coop/components';

import { Helpers } from '../../../../utility/helpers';

export const EXPIRE_IN_MINUTES = 60;

interface EditOrderSoonExpireDialogProps {
    handleConfirm: () => void;
    close: () => void;
    showDialog: boolean;
    editOrderExpirationTime: Date;
}

const EditOrderSoonExpireDialog = ({
    handleConfirm,
    close,
    showDialog,
    editOrderExpirationTime,
}: EditOrderSoonExpireDialogProps) => {
    return (
        <Confirm
            show={showDialog}
            heading={`Handla färdigt inom ${EXPIRE_IN_MINUTES} minuter`}
            message={`Din beställning börjar packas när klockan passerar ${Helpers.formatHHmm(
                editOrderExpirationTime,
            )}. Slutför ditt köp i kassan innan tiden går ut för att spara eventuella ändringar.`}
            confirmButtonText="Slutför köp"
            onConfirm={handleConfirm}
            close={close}
        />
    );
};

export default EditOrderSoonExpireDialog;
